import { http } from '@/lib/http'
import type { FeatureFlag } from '@/types/models'

export const flagsApi = {
  /** Every flag with the caller's effective status (overrides merged server-side). */
  list: () => http.get<FeatureFlag[]>('/feature-flags'),
}
